import AuthorsPage from '@/frontend/pages/search/AuthorsPage';
import CompilationsPage from '@/frontend/pages/search/CompilationsPage';
import WorksPage from '@/frontend/pages/search/WorksPage';
export default {
  name: "SearchPage",
  props: ['q'],
  components: {
    AuthorsPage,
    CompilationsPage,
    WorksPage
  },

  data() {
    return {
      tabs: ['AuthorsPage', 'WorksPage', 'CompilationsPage'],
      currentTabComponent: 'AuthorsPage',
      key: ''
    };
  },

  watch: {
    '$route.query.q'(value) {
      this.key = value;
    }

  }
};